import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCongratulationsUrl } from "../utils/urlHelper";

const congratulationsApi = createApi({
  reducerPath: "congratulations",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    fetchSanctionLetterDoc: builder.mutation({
      query: (body) => ({
        url: getCongratulationsUrl("fetch_sanction_letter"),
        method: "POST",
        body,
      }),
    }),
    userFeedback: builder.mutation({
      query: (body) => ({
        url: getCongratulationsUrl("feedback"),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useFetchSanctionLetterDocMutation,
  useUserFeedbackMutation,
} = congratulationsApi;

export { congratulationsApi };
